// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "template-assets/css/" + chunkId + "." + {"178": "74293d2f","213": "53665571","349": "dcc9ddd9","36": "d6431d10",}[chunkId] + ".css"
}